(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_blog-post-content"] && !Shopify.designMode) return;
  try {
    (function () {
    var wrapper = document.querySelector('[data-youtube-wrapper]');
    if (!wrapper) return;
    var videoId = wrapper.getAttribute('data-video-id');
    var frameContainer = wrapper.querySelector('[data-youtube-frame]');
    var target = frameContainer.querySelector('div');
    var cover = wrapper.querySelector('[data-cover]');
    var pauseBtn = wrapper.querySelector('[data-pause-btn]');
    var fullscreenBtn = wrapper.querySelector('[data-fullscreen-btn]');
    var iconExpand = wrapper.querySelector('[data-icon-expand]');
    var iconCollapse = wrapper.querySelector('[data-icon-collapse]');
    var player = null;

    function setPlayingState(isPlaying) {
      wrapper.classList.toggle('is-playing', isPlaying);
    }
    function loadYouTubeAPI(callback) {
      if (window.YT && window.YT.Player) { callback(); return; }
      var existing = document.querySelector('script[src="https://www.youtube.com/iframe_api"]');
      if (!existing) {
        var tag = document.createElement('script');
        tag.src = 'https://www.youtube.com/iframe_api';
        document.head.appendChild(tag);
      }
      var previous = window.onYouTubeIframeAPIReady;
      window.onYouTubeIframeAPIReady = function () {
        if (typeof previous === 'function') previous();
        callback();
      };
    }
    function initPlayer() {
      player = new YT.Player(target, {
        videoId: videoId,
        playerVars: { controls: 0, disablekb: 1, modestbranding: 1, rel: 0, iv_load_policy: 3, fs: 0, playsinline: 1 },
        events: {
          onStateChange: function (e) {
            setPlayingState(e.data === YT.PlayerState.PLAYING);
          }
        }
      });
    }
    loadYouTubeAPI(initPlayer);
    cover.addEventListener('click', function () {
      if (player && typeof player.playVideo === 'function') player.playVideo();
    });
    pauseBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      if (player && typeof player.pauseVideo === 'function') player.pauseVideo();
    });
    function isFullscreen() {
      return !!(document.fullscreenElement || document.webkitFullscreenElement || document.msFullscreenElement);
    }
    function updateFullscreenIcon() {
      var active = isFullscreen();
      iconExpand.style.display = active ? 'none' : 'block';
      iconCollapse.style.display = active ? 'block' : 'none';
    }
    fullscreenBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      if (isFullscreen()) {
        (document.exitFullscreen || document.webkitExitFullscreen || document.msExitFullscreen).call(document);
      } else {
        var el = wrapper;
        (el.requestFullscreen || el.webkitRequestFullscreen || el.msRequestFullscreen).call(el);
      }
    });
    document.addEventListener('fullscreenchange', updateFullscreenIcon);
    document.addEventListener('webkitfullscreenchange', updateFullscreenIcon);
    document.addEventListener('MSFullscreenChange', updateFullscreenIcon);
  })();
  } catch(e) { console.error(e); }
})();

})();
